// @flow

import type {TZoneList} from 'modules/console/types/zone-list';

type TConsoleInfo = {
    actualPoints: number,
    betterThenOthers: number,
    branding: TBranding,
    budget: number,
    confirmInProcess: boolean,
    efficiency: TEfficiency,
    exerciseAnswers: {},
    id: number,
    isConfirmed?: boolean,
    isInitialized: boolean,
    isReady: boolean,
    isReplayExercise: boolean,
    language: string,
    languageKey: string,
    name: string,
    gender: string,
    number: number,
    points: number,
    rating: number,
    zoneList: TZoneList[],
};
type TBranding = {
    brandingTypeId: number,
    companyLogo: string,
    defaultLogo: string,
};
type TEfficiency = {
    confidence?: number,
    cyberThreat?: number,
    domainsStatList?: {},
    numberOfZonesWithErrors?: number,
    similarSpeed?: number,
    speed?: number,
};

type TConsoleInfoState = TConsoleInfo;
const initialState: TConsoleInfoState = {
    branding: {},
    budget: 0,
    confirmInProcess: false,
    efficiency: {},
    exerciseAnswers: {},
    isInitialized: false,
    isReady: null,
    language: 'English',
    languageKey: 'en',
    name: 'Team',
    gender: null,
    number: 1,
    points: 0,
    rating: 0,
    zoneList: [],
};

type TSetConsoleInfo = {payload: TConsoleInfo, type: 'SET_CONSOLE_INFO'};
type TSetIsConfirmed = {payload: boolean, type: 'SET_IS_CONFIRMED'};
type TSetConfirmInProcess = {type: 'SET_CONFIRM_IN_PROCESS'};
type TSetConfirmStop = {type: 'SET_CONFIRM_STOP'};
type TSetVotingAnswer = {payload: {answerId: number, zoneId: number}, type: 'SET_VOTING_ANSWER'};

type TConsoleActionList = TSetConsoleInfo | TSetIsConfirmed | TSetConfirmInProcess | TSetConfirmStop | TSetVotingAnswer;

function consoleInfoReducer(state: TConsoleInfoState = initialState, {type, payload}: TConsoleActionList) {
    switch (type) {
        case 'SET_CONSOLE_INFO':
            return {
                ...state,
                ...payload,
            };
        case 'SET_CONFIRM_IN_PROCESS':
            return {
                ...state,
                confirmInProcess: true,
            };
        case 'SET_CONFIRM_STOP':
            return {
                ...state,
                confirmInProcess: false,
            };
        case 'SET_IS_CONFIRMED':
            return {
                ...state,
                isReady: payload,
            };
        case 'SET_VOTING_ANSWER': {
            return {
                ...state,
                zoneList: {
                    ...state.zoneList,
                    [payload.zoneId]: {
                        ...state.zoneList[payload.zoneId],
                        answerId: payload.answerId,
                    },
                },
            };
        }
        default:
            return state;
    }
}

export {consoleInfoReducer};
export type {
    TConsoleInfo,
    TSetConsoleInfo,
    TSetIsConfirmed,
    TConsoleInfoState,
    TSetConfirmInProcess,
    TSetConfirmStop,
    TSetVotingAnswer,
    TEfficiency,
    TBranding,
};
